import { UniversalCrud, UniversalDetail } from "@stdoutsrl/design-kit";
import { ExampleMonouseComponent } from "../tables-custom-actions/example-table-component.component";
import { api, environment } from "../../environments/environment";
import { ModalStoreDateComponent } from "../tables-custom-actions/modal-store-date/modal-store-date.component";

export const employees: UniversalCrud = {
  environment: environment,
  api: api,
  stepMinutes: 5,
  showClock: true,
  isPaginated: true,
  use24h: true,
  breadcrumb: [{ title: "employees", route: "/employees" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  table: [
    {
      element: "firstName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "lastName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "freeHours",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "maxDayHours",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "maxWeekHours",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "amountOfFreeHoursMonthly",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "jobs",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "multiselect",
      selectDataEndpoint: '/job?options={%22page%22:1,%22filters%22:[{%22s%22:%22jobType%22,%22v%22:[%22working%22,%22working_before%22,%22hard_working%22,%22working_hard_before%22,%22working_before_no_sunday%22],%22o%22:7}]}',
      multipleSelectArrayValue: false,
      bindLabelSelect: 'name',
      bindValueSelect: 'id',
      tableElementToVisualize: [{ paths: ['jobs'], useFixedValue: false, isObject: true }]
    },
    {
      element: "canWorkSunday",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      selectArray: [{ value: false, label: 'NO' }, { value: true, label: 'SI' }],
      translateValue: true,
    },
    {
      element: "storeIds",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "multiselect",
      selectDataEndpoint: '/store/all',
      bindValueSelect: 'id',
      multipleSelectArrayValue: false,
      bindLabelSelect: 'name',
      tableElementToVisualize: [{ paths: ['stores'], useFixedValue: false, isObject: true }]
    },
    {
      element: "isActive",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      selectArray: [{ value: false, label: 'NO' }, { value: true, label: 'SI' }],

      translateValue: true,
    },
  ],
  endpoint: "/employee",
};

export const jobs: UniversalCrud = {
  environment: environment,
  api: api,
  stepMinutes: 5,
  showClock: true,
  isPaginated: false,
  showSideNav: true,
  use24h: true,
  breadcrumb: [{ title: "jobs", route: "/jobs" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  table: [
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "color",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "color",
    },
    {
      element: "jobType",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      selectArray: [{ label: 'Lavorativo', value: 'working' }, { label: 'Ferie', value: 'permission' }, { label: 'Permesso(Non scala dal monte ore)', value: 'special' }, { label: 'Lavorativo inizia 1 ora prima', value: 'working_before' }, { label: 'Lavorativo fascia alta', value: 'hard_working' }, { label: 'Lavorativo fascia alta e inizio anticipato', value: 'working_hard_before' }, { label: 'Lavorativo inizio anticipato senza domenica', value: 'working_before_no_sunday' }, { label: 'Giorno libero', value: 'free' }]
    },
  ],
  endpoint: "/job",
};

export const stores: UniversalCrud = {
  route: 'stores',
  environment: environment,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  isPaginated: true,
  breadcrumb: [{ title: "store", route: "/store" }],
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  table: [
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      operators: {
        equal: true,
        notEqual: true,
        greaterThan: true,
        greaterThanOrEqual: true,
        lessThen: true,
        lessThanOrEqual: true,
        like: true,
        in: false,
        notIn: false,
        between: true,
        null: true,
        notNull: true,
      },
      obligatory: false,
      type: "text",
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "code",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "address",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "isActive",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      selectArray: [{ value: false, label: 'NO' }, { value: true, label: 'SI' }],

      translateValue: true,
    },
  ],
  endpoint: "/store",
  details: {
    route: "routes.store.path",
  },
};

export const managers: UniversalCrud = {
  route: 'managers',
  environment: environment,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  showSideNav: true,
  isPaginated: false,
  breadcrumb: [{ title: "managers", route: "/managers" }],
  canAddElement: true,
  canEditElement: false,
  canDeleteElement: true,
  customEndpoints: {
    create: "/user/admin/create",
    read: "/user/all",
    update: "",
    delete: "/user/admin"
  },
  table: [
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: false,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "email",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "firstName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "lastName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "storeIds",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "multiselect",
      selectDataEndpoint: '/store/all',
      bindValueSelect: 'id',
      multipleSelectArrayValue: false,
      bindLabelSelect: 'name',
      tableElementToVisualize: [{ paths: ['stores'], useFixedValue: false, isObject: true }],
    },
    {
      element: "roleId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      selectDataEndpoint: '/user/roles',
      tableElementToVisualize: [{ paths: ['roleInfo', 'name'], useFixedValue: false }],
      bindLabelSelect: 'name',
      bindValueSelect: 'id'
    },
  ],
  endpoint: "/user/all",
};

export const store: UniversalDetail = {
  environment: environment,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [
    { title: "events", route: "/events" },
    { title: "event", route: "/event" },
  ],
  details: stores.table,
  tables: [
    {
      canAddElement: false,
      canEditElement: false,
      canDeleteElement: true,
      customTableActions:[{
        component:ModalStoreDateComponent,
        icon:'./assets/edit.svg',
        iconClass:''
      }],
      customActions:[{
        component: ModalStoreDateComponent,
        label: 'Aggiungi',
        translateLabel: false
      }],
      endpoint: "timetables",
      name: "timetables",
      customAddLabel: "addTimeTable",
      active: true,

      table: [
        {
          element: "day",
          table: true,
          editable: true,
          translateValue: true,
          prefixTranslateValue: "daysOfTheWeek.",
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "select",
          selectArray: [
            {
              label: "Lunedi",
              value: 1,
            },
            {
              label: "Martedi",
              value: 2,
            },
            {
              label: "Mercoledi",
              value: 3,
            },
            {
              label: "Giovedi",
              value: 4,
            },
            {
              label: "Venerdi",
              value: 5,
            },
            {
              label: "Sabato",
              value: 6,
            },
            {
              label: "Domenica",
              value: 0,
            },
          ],
        },
        {
          element: "timeStart",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "time",
        },
        {
          element: "timeEnd",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "time",
        },
      ],
    },
    {
      canAddElement: true,
      canEditElement: true,
      canDeleteElement: true,
      endpoint: "dates",
      name: "dates",
      active: false,
      table: [
        {
          element: "date",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "date",
        },
        {
          element: "status",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: true,
          type: "select",
          selectArray: [
            {
              label: "Chiuso",
              value: 0,
            },
            {
              label: "Aperto",
              value: 1,
            },
          ],
        },
      ],
    },
  ],
  currentBreadcrumb: 1,
  endpoint: "/store",
};

export const employee: UniversalDetail = {
  environment: environment,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [
    { title: "employees", route: "/employees" },
    { title: "Employee", route: "/employee/:id" },
  ],
  customActionsTop: [
    {
      component: ExampleMonouseComponent,
      label: "Example Custom Action Top",
      translateLabel: false,
    },
    {
      component: ExampleMonouseComponent,
      label: "Example Custom Action Top 2",
      translateLabel: false,
    },
    {
      component: ExampleMonouseComponent,
      label: "Example Custom Action Top3 ",
      translateLabel: false,
    },
  ],
  customActionsCard: [
    {
      component: ExampleMonouseComponent,
      label: "Example Custom Action Card",
      translateLabel: false,
    },
    {
      component: ExampleMonouseComponent,
      label: "Example Custom Action Card 2",
      translateLabel: false,
    },
    {
      component: ExampleMonouseComponent,
      label: "Example Custom Action Card ",
      translateLabel: false,
    },
  ],
  currentBreadcrumb: 1,
  endpoint: "/employees",
  details: employees.table,
};

export const platforms: UniversalCrud = {
  environment: environment,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [{ title: "platforms", route: "/platforms" }],
  table: [
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "slug",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "text",
    },
  ],
  endpoint: "/platforms",
  canAddElement: false,
  canEditElement: false,
  canDeleteElement: false,
};

